<div class="">
  <span class="top-left-title-bar">{{title}}</span>
  <button (click)="close()" type="button" class="close mr-4 mt-3" aria-label="Close"
          style="outline: none !important;">
    <span aria-hidden="true">&times;</span>
  </button>
<!--  <span class="close-btn close" (click)="emitValue(false)"></span>-->
</div>
<div class="modal-body text-center mt-5 mb-4">
  {{message}}
</div>
<div class="modal-footer row justify-content-end" style="border:none; margin-top:-20px">


  <button type="button" class="cancel-button" (click)="close()" >
    Cancel
  </button>
  <button  class="add-btn" (click)="upload()" *ngIf="param=='fcaSubmit'&& failMessage!='All Provided Accounts are already planned'">
    Proceed
  </button>
  <button  class="add-btn" (click)="viewErrorReport()" *ngIf="failMessage!='All Provided Accounts are already planned'">
    View Error Report
  </button>
</div>
